import React from 'react';
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";

import SvgIcons from "../Icons/SvgIcons";
import {setWizardPopupOpened} from "./wizardActions";
import {WIZARD_POPUP_TYPES} from "./wizardReducer";


const WizardSetupTopButtonsCloneButton = (props) => {

  const {wizardList, wizardListReceived, setWizardPopupOpened} = props;

  const disabled = !wizardListReceived || !wizardList.length || !wizardList.some(wizardItem => wizardItem.selected);

  const cloneWizardClick = () => {
    if (disabled) {
      return false
    }
    setWizardPopupOpened(true, WIZARD_POPUP_TYPES.cloneWizard);
  }

  return (
    <button className={"ui-button--add ui-button5 ui-button5--gray ui-button5--select-all" + (disabled ? " ui-button5--disabled" : "")}
            onClick={cloneWizardClick}>
      <div className="ui-button-icon">
        {SvgIcons.cloneIcon}
      </div>
      <FormattedMessage id="wizard.cloneIntoButton"/>
    </button>
  )
};

const mapStateToProps = (store) => {
  const {wizardList, wizardListReceived} = store.wizardState;

  return {
    wizardList,
    wizardListReceived,
  };
};

const mapDispatchToProps = {
  setWizardPopupOpened
};

export default connect(mapStateToProps, mapDispatchToProps)(WizardSetupTopButtonsCloneButton)
